<template>
  <div>
    <el-card
      header="Group Information"
      shadow="never"      style="margin-bottom: 20px"
    >
      <el-row :gutter="24">
        <el-col :span="8" class="fact-col">
          <span>Group Limit：</span>
          <span>{{ groupLimit }}</span>
        </el-col>
        <el-col :span="8" class="fact-col">
          <span>Group Limit Expiry Date：</span>
          <span>{{ dueDate }}</span>
        </el-col>
        <el-col :span="8" class="fact-col">
          <span>Total Active Limit：</span>
          <span>{{ groupCreditLimit }}</span>
        </el-col>
      </el-row>
      <!-- 将 Group Type 移到新的 el-row 中实现换行 -->
      <el-row :gutter="24" style="margin-top: 20px;">
        <el-col :span="8" class="fact-col">
          <span>Group Type：</span>
          <span>
            {{
              groupType === '1' ? 'Legal' : groupType === '2' ? 'Business' : ''
            }}
          </span>
        </el-col>
      </el-row>
    </el-card>
    <el-card header="HIERARCHY TREE" shadow="never">
      <div class="wrapper">
        <el-tree
          default-expand-all
          :data="treeList"
          :props="defaultProps"
          @node-click="handleNodeClick"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <a
              href="javascript:void (0)"
              :style="{ fontWeight: data.current ? 'bold' : 'none' }"
            >
              {{ node.label }}
            </a>
          </span>
        </el-tree>
      </div>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      treeList: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      groupType: '',
      groupLimit: null,
      groupCreditLimit: null,
      dueDate: null, // 新增字段
    }
  },
  mounted() {
    this.getData()
    this.getGroupInformation()
    this.getGroupcreditLimit()
  },
  methods: {
    handleNodeClick({ id }) {
      let routeUrl = this.$router.resolve({
        path: `/customer-management/${id}/info`, // 对应路由
      })
      window.open(routeUrl.href, '_blank')
    },
    async getData() {
      try {
        this.treeList = await request.get(
          `/customer-api/company-relation/relation/view`,
          {
            companyId: this.$route.params.customerId,
          },
        )
      } catch (err) {
        console.error(err)
      }
    },
    async getGroupInformation() {
      try {
        const { groupLimit, groupType , dueDate} = await request.get(
          `/customer-api/customer/overview/${this.$route.params.customerId}`,
        )
        this.groupLimit = this.$utils.formatAmount(groupLimit)
        this.groupType = groupType
        this.dueDate = dueDate // 设置 dueDate 值
      } catch (err) {
        console.log(err)
      }
    },
    async getGroupcreditLimit() {
      try {
        const res = await request.get(
          `/customer-api/company-relation/relation/creditLimit?companyId=${this.$route.params.customerId}`,
        )
        this.groupCreditLimit = this.$utils.formatAmount(res)
      } catch (err) {
        console.log(err)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.wrapper {
  box-sizing: border-box;
  padding: 30px;
  min-height: 382px;
  background: #fbfbfd;
  border: 1px solid #dae0f2;
  border-radius: 8px;
}
</style>
